import { inject, Injectable } from '@angular/core';

import { TCapabilitiesFiltersDetails } from '@core/modules/capacities/domain/types';
import { CapabilitiesStore, TCapabilitiesFiltersStore } from '@core/stores';
import { CapabilitiesRepository } from '@data/repositories';
import { Command, Result } from '@domain/helpers';

@Injectable({
  providedIn: 'root',
})
export class SegmentedZoneCapabilitiesFacade {
  private readonly capabilitiesRepository = inject(CapabilitiesRepository);
  private readonly store = inject(CapabilitiesStore);

  readonly listCapabilities = new Command(
    (filters: TCapabilitiesFiltersStore) =>
      this._getSegmentedZoneCapabilities(filters),
  );

  private async _getSegmentedZoneCapabilities(
    filters: TCapabilitiesFiltersStore,
  ) {
    const date = filters.date.toFormat('yyyy-MM-dd');
    this.store.setFilters(filters);

    const formData: TCapabilitiesFiltersDetails = {
      filial: filters.filial,
      operation: filters.operation,
      date,
    };

    const result =
      await this.capabilitiesRepository.listCapabilitiesByDay(formData);

    if (result.isOk === false) {
      this.store.addSegmentedCapabilities([]);
      this.store.setBagCapabilities('', []);
      return result;
    }

    if (result.data.length === 0) {
      this.store.setBagCapabilities('', []);
      this.store.addSegmentedCapabilities([]);
      return Result.failed(new Error('No se encontraron capacidades'));
    }

    const segmentedCapabilities = result.data.map((item) => item.toJson());

    const segmentedZoneId = segmentedCapabilities.find(
      (sz) => sz.capability_type !== 'FILIAL',
    )?.segmented_zone_id;

    const resultBags =
      await this.capabilitiesRepository.getBagsCapabilitiesBySegmentedZone({
        id: segmentedZoneId,
        date,
      });

    if (resultBags.isOk === false) {
      this.store.setBagCapabilities('', []);
      this.store.addSegmentedCapabilities([]);
      return resultBags;
    }

    this.store.addSegmentedCapabilities(segmentedCapabilities);
    this.store.setBagCapabilities(segmentedZoneId, resultBags.data);

    return Result.success(segmentedCapabilities);
  }
}
